import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hunterIo = defineConnector({
  identifier: "hunterIo",
  name: "Hunter.io",
  tagLine: "Email finder and verification",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.hunter\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log into [Hunter.io](https://hunter.io) and go to **API** in your dashboard to copy your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.hunter.io/v2/account",
  },
});
